/* eslint-disable */
import * as Types from '../../../../../generated/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type GQLProfileVisitedCountriesQueryVariables = Types.Exact<{
  limitCountries: Types.Scalars['Int']['input']
}>

export type GQLProfileVisitedCountriesQuery = {
  __typename?: 'Query'
  my: {
    __typename?: 'My'
    id: any
    travelAtlas: {
      __typename?: 'MyTravelAtlas'
      visitedCountries: {
        __typename?: 'MyTravelAtlasVisitedCountries'
        visitedCountriesCount: number
        visitedCountries: {
          __typename?: 'MyTravelAtlasVisitedCountriesConnection'
          nodes: Array<{
            __typename?: 'MyTravelAtlasVisitedCountry'
            visible: boolean
            country: {
              __typename?: 'Country'
              id: string
              code: string
              isoCode: string
              name: string
            }
          }>
        }
      }
    }
  }
}

export type GQLMyTravelAtlasFragment = {
  __typename?: 'My'
  travelAtlas: {
    __typename?: 'MyTravelAtlas'
    visitedCountries: {
      __typename?: 'MyTravelAtlasVisitedCountries'
      visitedCountriesCount: number
      visitedCountries: {
        __typename?: 'MyTravelAtlasVisitedCountriesConnection'
        nodes: Array<{
          __typename?: 'MyTravelAtlasVisitedCountry'
          visible: boolean
          country: {
            __typename?: 'Country'
            id: string
            code: string
            isoCode: string
            name: string
          }
        }>
      }
    }
  }
}

export const MyTravelAtlasFragmentDoc = gql`
  fragment MyTravelAtlas on My {
    travelAtlas {
      visitedCountries {
        visitedCountries(limit: $limitCountries, after: null) {
          nodes {
            country {
              id
              code
              isoCode
              name
            }
            visible
          }
        }
        visitedCountriesCount
      }
    }
  }
`
export const ProfileVisitedCountriesDocument = gql`
  query ProfileVisitedCountries($limitCountries: Int!) {
    my {
      id
      ...MyTravelAtlas
    }
  }
  ${MyTravelAtlasFragmentDoc}
`

/**
 * __useProfileVisitedCountriesQuery__
 *
 * To run a query within a React component, call `useProfileVisitedCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileVisitedCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileVisitedCountriesQuery({
 *   variables: {
 *      limitCountries: // value for 'limitCountries'
 *   },
 * });
 */
export function useProfileVisitedCountriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQLProfileVisitedCountriesQuery,
    GQLProfileVisitedCountriesQueryVariables
  > &
    (
      | { variables: GQLProfileVisitedCountriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQLProfileVisitedCountriesQuery,
    GQLProfileVisitedCountriesQueryVariables
  >(ProfileVisitedCountriesDocument, options)
}
export function useProfileVisitedCountriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQLProfileVisitedCountriesQuery,
    GQLProfileVisitedCountriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQLProfileVisitedCountriesQuery,
    GQLProfileVisitedCountriesQueryVariables
  >(ProfileVisitedCountriesDocument, options)
}
export function useProfileVisitedCountriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQLProfileVisitedCountriesQuery,
        GQLProfileVisitedCountriesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQLProfileVisitedCountriesQuery,
    GQLProfileVisitedCountriesQueryVariables
  >(ProfileVisitedCountriesDocument, options)
}
export type ProfileVisitedCountriesQueryHookResult = ReturnType<
  typeof useProfileVisitedCountriesQuery
>
export type ProfileVisitedCountriesLazyQueryHookResult = ReturnType<
  typeof useProfileVisitedCountriesLazyQuery
>
export type ProfileVisitedCountriesSuspenseQueryHookResult = ReturnType<
  typeof useProfileVisitedCountriesSuspenseQuery
>
export type ProfileVisitedCountriesQueryResult = Apollo.QueryResult<
  GQLProfileVisitedCountriesQuery,
  GQLProfileVisitedCountriesQueryVariables
>
